module.exports = __webpack_public_path__ + "img/christmassweater.c1ad95d0.svg";